import React, { useState } from "react";
import gallery1 from "../assets/section-image-1.jpg";
import gallery2 from "../assets/section-image-2.jpg";
import gallery3 from "../assets/section-image-3.jpg";
import gallery4 from "../assets/section-image-4.jpg";
import gallery5 from "../assets/section-image-6.jpg";
import gallery6 from "../assets/section-image-5.jpg";

const AboutSection = () => {
    const [personalShowMore, setPersonalShowMore] = useState(false);
    const [businessShowMore, setBusinessShowMore] = useState(false);
    const [homeShowMore, setHomeShowMore] = useState(false);
    const [mortgageShowMore, setMortgageShowMore] = useState(false);
    const [nriShowMore, setNriShowMore] = useState(false);
    const [transferShowMore, setTransferShowMore] = useState(false);

  return (
    <div className="about-section-comp">
      {/* <div className="about-section-container"> */}
      {/* <div className="about-gallery-row">
        <div className="about-gallery-column1">
          <img
            src={gallery1}
            alt="gallery1"
            className="aboutus-gallery1-img"
          />
          <img
            src={gallery2}
            alt="gallery2"
            className="aboutus-gallery2-img"
          />
        </div>
        <div className="about-gallery-column2">
          <img
            src={gallery3}
            alt="gallery3"
            className="aboutus-gallery3-img"
          />
          <img
            src={gallery4}
            alt="gallery4"
            className="aboutus-gallery4-img"
          />
        </div>
        <div className="about-gallery-column3">
          <img
            src={gallery5}
            alt="gallery5"
            className="aboutus-gallery5-img"
          />
          <img
            src={gallery6}
            alt="gallery6"
            className="aboutus-gallery6-img"
          />
        </div>
      </div> */}
      {/* </div> */}
      <div className="about-section-services">
        <p>View Our Services & Product Overview</p>
      </div>
      <div className="about-product-content">
        <div className="about-section-description">
          <h4 className="product-service-title">Personal Loan</h4>

          <p className="about-section-para">
            <span className="about-questions-icon">●</span>
            <span className="highlight-color">
              The only loan that gets credited to your account within 10 minutes
            </span>
            , a personal loan is an unsecured financial solution designed for
            instant needs. Offered by banks, NBFCs, and digital lenders without
            requiring collateral, it is approved based on your income, credit
            score, and repayment history. The amount can be used for any purpose
            such as medical emergencies, weddings, travel, education, home
            renovation, With repayment through fixed EMIs over flexible tenures
            of one to seven years, personal loans are popular for their quick
            approval, minimal documentation, and complete freedom of usage.
            Right Lender brings{" "}
            {!personalShowMore ? (
              <>
                ...{" "}
                <span
                  className="read-more-toggle"
                  onClick={() => setPersonalShowMore(true)}
                >
                  Read More
                </span>
              </>
            ) : (
              <>
                <span className="highlight-color">
                  you the best personal loan offers by partnering with over 40+
                  top Banks and NBFCs, covering a wide range of profiles —
                  helping you find the perfect Lender for your financial needs —
                  all in one place.
                </span>
                <br />
                <div className="mt-2">
                  <span className="about-questions-icon">●</span>
                  <span className="highlight-color">
                    With loan amounts available up to ₹50 Lakhs*
                  </span>
                  , we ensure you get access to real-time, personalized offers
                  based on your profile. The process is completely digital and
                  secure. Whether you apply through{" "}
                  <span className="highlight-color">web, Android, or iOS</span>,
                  <span
                    className="read-more-toggle"
                    onClick={() => setPersonalShowMore(false)}
                  >
                    {" "}
                    Read Less
                  </span>
                </div>
              </>
            )}
          </p>
        </div>

        <div className="about-section-description">
          <h4 className="product-service-title">Business Loan</h4>

          <p className="about-section-para">
            <span className="about-questions-icon">●</span>
            <span className="highlight-color">
              The only loan that helps your business grow by providing quick
              funds when you need them most
            </span>
            , a business loan is designed to support entrepreneurs,
            professionals, and enterprises without requiring collateral in many
            cases. Banks, NBFCs, and digital lenders offer these loans based on
            your business performance, turnover, credit history, and repayment
            capacity. The funds can be used for working capital, purchasing
            equipment, managing inventory, business expansion, or meeting
            operational expenses. With flexible tenures and repayment through
            EMIs, business loans give you the freedom to focus on growth while
            ensuring{" "}
            {!businessShowMore ? (
              <>
                ...{" "}
                <span
                  className="read-more-toggle"
                  onClick={() => setBusinessShowMore(true)}
                >
                  Read More
                </span>
              </>
            ) : (
              <>
                <span className="highlight-color">
                  smooth cash flow and stability.
                </span>
                <br className="mt-4" />
                <div className="mt-2">
                  <span className="about-questions-icon">●</span>
                  <span className="highlight-color">
                    Collateral-free Business Loan up to ₹1 Crore. Fuel your
                    business with the right funding from the Right Lender
                  </span>
                  — based on your business income. We help you get
                  collateral-free loans for stock purchases, working capital,
                  OD/CC, term loans, and OD balance transfers. Our platform
                  supports GST registered businesses across Retail,
                  Distributors, food, manufacturing, wholesale, trading, and
                  service sectors — through a fully digital process. Faced a
                  funding shortage with your previous business loan? Paid higher
                  interest than expected? Right Lender guides you to the
                  best-fit offer, so you can meet your business expansion needs
                  with the lowest rates and no hassle.
                  <br />
                  <span
                    className="read-more-toggle"
                    onClick={() => setBusinessShowMore(false)}
                  >
                    Read Less
                  </span>
                </div>
              </>
            )}
          </p>
        </div>

        <div className="about-section-description">
          <h4 className="product-service-title">Home Loan</h4>
          <p className="about-section-para">
            <span className="about-questions-icon">●</span>A home loan helps
            turn your dream home into reality by providing long-term financing
            to purchase, build, or renovate residential property. Offered by
            banks and NBFCs at comparatively lower interest rates, it is a
            secured loan where the property itself acts as collateral.{" "}
            <span className="highlight-color">
              Home loans come with flexible tenures of up to 30 years
            </span>
            , making repayment easier through affordable EMIs. The funds can be
            used for buying a new house, constructing your own home, purchasing
            a plot, or renovating an existing property. With tax benefits,
            attractive interest rates, and higher eligibility, a home loan is
            the most reliable way to achieve home
            {!homeShowMore ? (
              <>
                ...{" "}
                <span
                  className="read-more-toggle"
                  onClick={() => setHomeShowMore(true)}
                >
                  Read More
                </span>
              </>
            ) : (
              <>
                {" "}
                ownership without draining your savings.
                <div className="mt-2">
                  <span className="about-questions-icon">●</span>
                  <span className="highlight-color">
                    Get home loan deals of up to ₹10 Crores from 60+ top Banks
                    and NBFCs through Right Lender
                  </span>
                  . Whether you're purchasing a flat, apartment, villa, or
                  commercial property, or planning to construct your dream home,
                  we help you secure the right funding at the lowest possible
                  interest rates —{" "}
                  <span className="highlight-color">
                    for both residential and commercial purposes
                  </span>
                  .{" "}
                  <span
                    className="read-more-toggle"
                    onClick={() => setHomeShowMore(false)}
                  >
                    Read Less
                  </span>
                </div>
              </>
            )}
          </p>
        </div>

        <div className="about-section-description">
          <h4 className="product-service-title">Mortgage Loan</h4>

          <p className="about-section-para">
            <span className="about-questions-icon">●</span>
            <span className="highlight-color">
              A mortgage loan allows you to unlock the value of your property
              and access large funds at affordable rates without selling your
              asset.
            </span>
            A mortgage loan is a type of secured loan where you pledge an
            immovable asset, such as a house, commercial property, or land, as
            collateral to borrow money from a bank or NBFC. The lender keeps the
            property as security until the loan is fully repaid, but you can
            continue to use the property during this period. Mortgage loans are
            commonly used for purposes like business expansion, consolidating
            debt, medical needs, education, or other personal and professional
            requirements. Since the loan is{" "}
            {!mortgageShowMore ? (
              <>
                ...{" "}
                <span
                  className="read-more-toggle"
                  onClick={() => setMortgageShowMore(true)}
                >
                  Read More
                </span>
              </>
            ) : (
              <>
                backed by property, the interest rates are generally lower and
                repayment tenures are longer, often ranging from 5 to 15 years.
                <div className="mt-2">
                  <span className="about-questions-icon">●</span>
                  Unlock the potential of your residential or commercial
                  property with funding options of up to{" "}
                  <span className="highlight-color">
                    ₹10 Crores from 60+ top Banks and NBFCs.
                  </span>
                  Ideal for business expansion, education, or medical needs.
                  Whether you're salaried, self-employed, a professional, or an
                  NRI, if you own property in your name or that of a close
                  family member, Right Lender helps you access high-value,
                  flexible funding — quickly and effortlessly.
                  <br />
                  <span
                    className="read-more-toggle"
                    onClick={() => setMortgageShowMore(false)}
                  >
                    Read Less
                  </span>
                </div>
              </>
            )}
          </p>
        </div>

        <div className="about-section-description">
          <h4 className="product-service-title">NRI Loan</h4>
          <p className="about-section-para">
            <span className="about-questions-icon">●</span>
            NRI loans — whether for home purchase, business, or personal use —
            make it easier for Indians abroad to invest, manage expenses, and
            stay financially connected to India. An NRI loan is a customized
            financial solution designed for Non-Resident Indians (NRIs) to help
            them meet various needs in India while residing abroad. The most
            common type is an NRI home loan, which allows NRIs to purchase,
            construct, or renovate property in India. In addition, some banks
            and NBFCs also offer{" "}
            <span className="highlight-color">
              NRI personal loans that provide quick funds for purposes like
              medical emergencies, education, weddings, travel, or other
              personal expenses without{" "}
              {!nriShowMore ? (
                <>
                  ...{" "}
                  <span
                    className="read-more-toggle"
                    onClick={() => setNriShowMore(true)}
                  >
                    Read More
                  </span>
                </>
              ) : (
                <>
                  the need for collateral.
                  <div className="mt-2">
                    <span className="about-questions-icon">●</span>
                    Eligibility depends on factors such as country of residence,
                    income, employer profile, credit score, and repatriation
                    rules. The loan process is usually digital, and applicants
                    need to submit documents like an Indian passport, valid
                    visa, overseas employment proof, salary slips, NRE/NRO
                    account statements, and property papers (for secured loans).
                  </div>
                  <div className="mt-2">
                    <span className="about-questions-icon">●</span>
                    No matter where you’re working abroad, you can easily apply
                    for a Personal Loan, Home Loan, or Mortgage Loan against
                    your property in India. With leading banks offering high
                    funding at the lowest interest rates, the entire process is
                    seamless and fully managed remotely.{" "}
                    <span className="highlight-color">
                      You can complete every step from abroad—even before
                      visiting India*
                    </span>
                    . Right Lender handles everything on your behalf*, ensuring
                    a smooth and hassle-free experience, right from where you
                    are.{" "}
                    <span
                      className="read-more-toggle"
                      onClick={() => setNriShowMore(false)}
                    >
                      Read Less
                    </span>
                  </div>
                </>
              )}
            </span>
          </p>
        </div>

        <div className="about-section-description">
          <h4 className="product-service-title">Balance Transfer</h4>

          <p className="about-questions">
            Easy Transfer of Existing Loans - Get More Pay Less
          </p>

          <p className="about-section-para">
            <span className="about-questions-icon">●</span>A balance transfer
            loan helps you save money, reduce EMIs, and improve cash flow by
            moving your loan to a lender offering more favorable terms.
          </p>

          <p className="about-section-paragraph">
            <span className="about-questions-icon">●</span>A balance transfer
            loan is a facility that allows you to{" "}
            <span className="highlight-color">
              transfer your existing loan (such as a personal loan, home loan,
              car loan, or credit card outstanding) from one bank or NBFC to
              another
            </span>{" "}
            that offers a lower interest rate, better terms, or flexible
            repayment options. The main purpose is to reduce the overall cost of
            borrowing, lower EMI burden, or consolidate multiple
            {!transferShowMore ? (
              <>
                ...{" "}
                <span
                  className="read-more-toggle"
                  onClick={() => setTransferShowMore(true)}
                >
                  Read More
                </span>
              </>
            ) : (
              <>debts into a single manageable loan.</>
            )}
          </p>

          {transferShowMore && (
            <>
              <p className="about-section-paragraph">
                <span className="about-questions-icon">●</span>
                When you opt for a balance transfer, the new lender pays off the
                outstanding dues to your existing lender , and you begin
                repayment with the new lender under revised terms. Many lenders
                also offer top-up loans during a balance transfer, giving you
                access to additional funds along with the transferred loan.
                Eligibility for a balance transfer depends on your repayment
                history, credit score, income, and remaining loan tenure.
                Borrowers with a good track record of timely EMI payments
                usually get the best offers. While processing fees and charges
                may apply, the savings in interest and improved repayment
                structure often outweigh the costs.
              </p>

              <p className="about-section-paragraph">
                <span className="about-questions-icon">●</span>
                Why Balance Transfer is Important? Many people continue paying
                high interest rates on their existing loans — such as Personal
                Loans, Home Loans, Mortgage Loans, OD/CC, or multiple credit
                cards — often without realizing that they may be eligible for
                much lower rates. In many cases, loans are taken without
                properly analyzing the best available options, leading to
                unnecessary financial strain. However, once the lock-in period
                ends, there's no reason to keep overpaying.
              </p>

              <p className="about-section-paragraph">
                <span className="about-questions-icon">●</span>
                Right Lender helps you switch to the lowest possible interest
                rates by identifying where you qualify for the best real-time
                offers from 65+ banks and NBFCs. Benefit from reduced processing
                fees, top-up loan options, and a smooth, digital transfer
                experience. Along with Right Lender Rewards Just apply once to
                check your eligibility and unlock the lowest rates — saving both
                money and time with Right Lender by your side. We are currently
                servicing Tamil Nadu and Bangalore, expanding soon across India.
                (Excepting Personal Loan)
                <br />
                <span
                  className="read-more-toggle"
                  onClick={() => setTransferShowMore(false)}
                >
                  Read Less
                </span>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
